
 export class ComponentBase {

  errorMessage: string;
  isWaiting: boolean;


  constructor(){}
}